import { render, staticRenderFns } from "./EditShopDialog.vue?vue&type=template&id=48ee8d75&scoped=true&lang=pug&"
import script from "./EditShopDialog.vue?vue&type=script&lang=ts&"
export * from "./EditShopDialog.vue?vue&type=script&lang=ts&"
import style0 from "./EditShopDialog.vue?vue&type=style&index=0&id=48ee8d75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ee8d75",
  null
  
)

export default component.exports